module.exports = __webpack_public_path__ + "assets/img/Purchasing.a9e9dbf0.svg";